<template>
  <b-container id="landing-top">
    <b-row>
      <b-col>
        <div class="menu-notice">
          <h1 class="h1">
            {{welcomeText}}
            <transition name="m-fade" style="min-width: 100px">
              <span v-show="username.length > 0">{{username}}</span>
            </transition>
          </h1>
          <p class="menu-notice-p">How can we help you today?</p>
        </div>
        <div class="menu-box">
          <div href="#" v-for = "menu in menus"
               class="menu-card"
               v-scroll-to="menu.point" v-m-ua-event="['landing', 'banner', menu.title]">
            <div class="img-box">
              <img :src="menu.img" class="img"/>
            </div>
            <h3 class="menuh3">{{menu.title}}</h3>
            <p>{{menu.desc}}</p>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  export default {
    data () {
      return {
        menus: [{
          title: 'Reach New Prospects',
          desc: '... through traditional direct mail or via a digital marketing campaign.',
          img: './static/img/prospectLists.png',
          point: '#prospects'
        }, {
          title: 'Enhance or Clean My Customer Database',
          desc: '... by verifying or by enhancing the information I have collected.',
          img: './static/img/dataEnhancement.png',
          point: '#service'
        }, {
          title: 'Analyze My Customers',
          desc: '... to discover characteristics they may share with others in my area.',
          img: './static/img/portraitReportsWhite.png',
          point: '#analyze'
        }]
      }
    },
    computed: {
      username () {
        return this.$store.state.site.User_FullName || ''
      },
      welcomeText () {
        let text = ''
        let now = new Date().getHours()
        if (now >= 5 && now < 12) {
          text = 'Good morning'
        } else if (now >= 12 && now < 18) {
          text = 'Good afternoon'
        } else if (now >= 18 && now < 22) {
          text = 'Good evening'
        } else {
          text = 'Good night'
        }
        return text + ', '
      }
    }
  }
</script>

<style scoped lang="scss">
  .h1 {
    font-size: 48px;
    color: $color-primary;
    margin-top: 32px;
  }
  .menu-notice {
    margin-top: 16px;
    text-align: center;
  }
  .menu-notice-p {
    font-size: 18px;
  }
  .menu-box {
    display: flex;
    justify-content: center;
    flex-direction: row;
  }
  .menu-card {
    margin-top: 16px;
    padding: 16px;
    background-color: #fff;
    min-width: 250px;
    max-width: 400px;
    width: 25%;
    border-radius: 8px;
    cursor: pointer;
    margin-right: 24px;
  }
  .menu-card:hover {
    transform: scale(1.05);
  }
  .banner {
    width: 100%;
    height: 464px;
    background-color: #eee;
    margin-top: 32px;
  }
  .img {
    width: 80%;
  }
  .img-box {
    width: 100%;
    text-align: left;
    height:100px;
    overflow: hidden;
    margin-bottom: 24px;
  }
  .menuh3{
    margin-bottom: 1px;
    font-size: 18px;
  }
</style>



// WEBPACK FOOTER //
// src/components/landings/MSectionBanner.vue